import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/onexistence.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {       /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
        Shelfmark LH 4, 3, 5e Bl. 30<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: 1700 - 1701<br /><br />
        Translated from the Latin<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (252k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz: On Existence and Reality</title> {/*Change title*/}
            <meta name="description" content="An English translation of ON EXISTENCE AND REALITY by Gottfried Wilhelm Leibniz, from 1700 - 1701" /> {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON EXISTENCE AND REALITY</h2> {/*Change title*/}
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br /> {/*Change page content*/}
                 <small>The watermark is well-attested to 1700, but is also found in a writing as late as April 1701.<a name="1" href="#note1"><sup>1</sup></a></small><br /><br />
                 [<b>LH 4, 3, 5e Bl. 30r</b>]<br /><br />
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a name="2" href="#note2"><sup>2</sup></a> In philosophizing, I assume that something exists, and since there is nothing without a reason, there must be a reason why something<a name="3" href="#note3"><sup>3</sup></a> exists rather than nothing.<a name="4" href="#note4"><sup>4</sup></a> And this reason must be grounded in a necessary thing, for the contingent does not have within its nature a reason for existing, and so is not the ground of existing. Furthermore, the cause that ensures that something exists rather than nothing also ensures that there exists more rather than less, for the reason is the act or prevalence of the existifying in the cause or principle of existing things. And from this arises my great axiom<a name="5" href="#note5"><sup>5</sup></a> of perfection, that the greatest reality that can be had comes forth.<a name="6" href="#note6"><sup>6</sup></a><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Reality, moreover, is to be assessed by<a name="7" href="#note7"><sup>7</sup></a> the multitude, variety, and order of things, and, in short, by the degree of intelligibility, which also shows that all things exist for the sake of intelligent beings. In a multitude without variety there would not be sufficient reality, for reality is to be assessed not only by matter but also by forms, and instead of many things similar in all respects, one would suffice, lest other things be deprived a place. Order in variety provides a certain unity in multiplicity, so that all things are related to one another as much as possible, and all things are done with the highest reason. A unique or determinate thing must be chosen instead of duplicate things, that is, those having no prerogative over each other, as otherwise more things would be selected than would be necessary were a unique thing used.<a name="8" href="#note8"><sup>8</sup></a> The rule of maximum and minimum is observed everywhere: the minimum in subject, space, time, and matter, and the maximum of form, power, and reason. No vacuum, no atoms, no first elements, [instead] worlds within worlds without end, so that places and bodies are not left barren. No change occurs through a leap, as a leap would be a kind of vacuum or gap in forms, where a great and ordered variety can be interposed that should not be neglected. The quantity of action and power is always the same, namely the greatest, because that is possible, whereas the degree of perfection is not always the same, for that is not possible, as otherwise no change could occur, since it would not be directed toward an end. Therefore, the world always tends toward greater perfection and by unfolding itself it learns to express its author more perfectly, nor are its involutions equivalent to its evolutions.<br /><br />

[<b>LH 4, 3, 5e Bl. 30v</b>]<br /><br />

That not only from the circumstances of the times, but also from the new discoveries, through which the nature of both bodies and<a name="9" href="#note9"><sup>9</sup></a>

                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> See A IV 8, 630-633.<br />
                <a name="note2" href="#2">2.</a> │ The principle of my philosophy is: something │ <var>deleted</var>.<br />
                <a name="note3" href="#3">3.</a> something │ prevails │ <var>deleted</var>.<br />
                <a name="note4" href="#4">4.</a> nothing │ [1] , since from nothing │ [2] , for since it cannot [come] from nothing, it is evident [it comes] from a thing, but the thing which is the reason for existing in things rather than │ <var>deleted</var>.<br />
                <a name="note5" href="#5">5.</a> axiom │ of the maximum │ <var>deleted</var>.<br />
                <a name="note6" href="#6">6.</a> forth. │ ¶ Having established the axiom of perfection, from this it follows │ <var>deleted</var>.<br />
                <a name="note7" href="#7">7.</a> by │ multitude, variety, and order, that is, intelligibility; │ <var>deleted</var>.<br />
                <a name="note8" href="#8">8.</a> used. │ There is no vacuum because it would not provide the opportunity for producing so many things │ <var>deleted</var>.<br />
                <a name="note9" href="#9">9.</a> This incomplete sentence was written in German.<br /><br /><br />
                  &#169; Lloyd Strickland 2025
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
